import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { showAnimation } from 'src/animations';
import { OnlyofficeDialogComponent, OnlyofficeDialogComponentData } from 'src/app/lib/nextcloud/components/dialog/onlyoffice-dialog/onlyoffice-dialog.component';
import { LocalFile, NextcloudFile } from 'src/app/lib/nextcloud/classes';
import { maxFileSize } from 'src/app/lib/nextcloud/globals';
import { FileService } from 'src/app/services/file.service';
import { Issue, UploadFileTask } from '../../../classes';
import { IIssueProviderService, IIssueTransactionView, ISSUE_PROVIDER_SERVICE } from '../../../interfaces';
import { Step, STEP_FORM_GROUP } from '../../dialog/issue-transaction-dialog2/issue-transaction-dialog2-component-classes';

@Component({
  selector: 'app-upload-form',
  templateUrl: './upload-form.component.html',
  styleUrls: ['./upload-form.component.css'],
  animations: [showAnimation]
})
export class UploadFormComponent implements IIssueTransactionView, OnDestroy, OnInit {

  nextcloudError: boolean = false;

  files: LocalFile[] = [];

  counter: number = 0;

  nextcloudFolder: NextcloudFile[] = [];

  _subscriptions: Subscription[] = [];

  constructor(
    @Inject('step') private _step: Step,
    @Inject(ISSUE_PROVIDER_SERVICE) private _issueService: IIssueProviderService,
    @Inject(STEP_FORM_GROUP) public formGroup: FormGroup,
    private _fileService: FileService,
    private _snackBar: MatSnackBar,
    private _dialog: MatDialog
  ) { }

  filesSelected(files) {
    var dropped = [];
    for (let file of files) {
      if ((file as File).size > maxFileSize) {
        dropped.push((file as File).name);
        continue;
      }
      if ((this.uploadControl.value as UploadFileTask).data.has(file.name)) continue;
      (this.uploadControl.value as UploadFileTask).data.append(file.name, file, file.name);
    }
    if (dropped.length > 0) {
      this._snackBar.open(`${dropped.length === 1 ? 'Die Datei ist' : `${dropped.length} Dateien sind`} zu groß für den Upload (maximal erlaubt: ${maxFileSize / 1000000}MByte).`, 'Upload', {
        'duration': 3000
      });
    }
    this.validateFiles();
  }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this._issueService.issue$.pipe(tap(x =>  {
        console.log(x);
      }), filter(x => x ? true : false), switchMap((issue: Issue) => this._fileService.getFolderByPath(issue.folderlocation))).subscribe(
        (nextcloudFiles: NextcloudFile[]) => {
          this.nextcloudFolder = nextcloudFiles;
          this.nextcloudError = false;
        },
        (error) => this.nextcloudError = true
      )
    ]);
    this.validateFiles();
  }

  previewFile(event: Event, file: NextcloudFile) {
    event.stopPropagation();
    console.log(file);
    if(file.type === 'folder') return;
    if (FileService.useWithNextcloud(file.type)) {
      this._dialog.open(OnlyofficeDialogComponent, {
        panelClass: "no-padding-dialog-container",
        autoFocus: false,
        data: {
          'file': file
        } as OnlyofficeDialogComponentData
      });
    } else {
      this._fileService.getFileByPath(file.href).subscribe(
        (result: Blob) => {
          window.open(URL.createObjectURL(result));
        },
        (error: HttpErrorResponse) => {
          this._snackBar.open(`Problem beim Anzeigen der Datei: ${error.message}`);
        }
      );
    }
  }

  removeUploadFile(event: Event, file: LocalFile) {
    event.stopPropagation();
    ((this.uploadControl.value as UploadFileTask).data).delete(file.localName);
    this.validateFiles();
  }

  validateFiles() {
    let files = [];
    this.counter = 0;
    ((this.uploadControl.value as UploadFileTask).data).forEach((x: File) => {
      this.counter++;
      files.push({
        'isLocalFile': true,
        'localName': x.name,
        'size': x.size,
        'type': x.type
      } as LocalFile);
    });
    this.files = files;
    this._step.visibleInConclusion = this.counter > 0? true: false;
  }

  get uploadControl(): AbstractControl {
    return this.formGroup.controls['upload'];
  }

}
